import React, { useEffect, useState } from 'react';
import { SLA_OVERRIDE_OTHER_CODE, resolveSlaOverrideReason } from './sla-override-reason-options';

const fieldStyle = {
    width: '100%',
    padding: '8px 12px',
    fontSize: '14px',
    border: '1px solid #d1d5db',
    borderRadius: '6px',
    boxSizing: 'border-box',
    backgroundColor: '#fff',
};

const labelStyle = {
    display: 'block',
    marginBottom: '6px',
    fontSize: '13px',
    fontWeight: 500,
    color: '#374151',
};

export function useSlaOverrideReason(open, resetKey) {
    const [selectedCode, setSelectedCode] = useState('');
    const [otherText, setOtherText] = useState('');

    useEffect(() => {
        if (open) {
            setSelectedCode('');
            setOtherText('');
        }
    }, [open, resetKey]);

    const resolved = resolveSlaOverrideReason(selectedCode, otherText);

    return { selectedCode, setSelectedCode, otherText, setOtherText, resolved };
}

const SlaOverrideReasonFields = ({ options = [], selectedCode, onSelectedCodeChange, otherText, onOtherTextChange }) => (
    <div style={{ marginTop: '16px' }}>
        <label style={labelStyle} htmlFor="sla-override-reason">
            Reason (required)
        </label>
        <select
            id="sla-override-reason"
            value={selectedCode}
            onChange={(e) => onSelectedCodeChange(e.target.value)}
            style={fieldStyle}
        >
            <option value="">Select reason…</option>
            {options.map((opt) => (
                <option key={opt.code} value={opt.code}>{opt.label}</option>
            ))}
        </select>
        {selectedCode === SLA_OVERRIDE_OTHER_CODE && (
            <div style={{ marginTop: '12px' }}>
                <label style={labelStyle} htmlFor="sla-override-reason-detail">
                    Details (required)
                </label>
                <input
                    id="sla-override-reason-detail"
                    type="text"
                    value={otherText}
                    onChange={(e) => onOtherTextChange(e.target.value)}
                    placeholder="Describe the reason"
                    style={fieldStyle}
                />
            </div>
        )}
    </div>
);

export default SlaOverrideReasonFields;
